import { render, staticRenderFns } from "./InvesteeInfo.vue?vue&type=template&id=50630f1a&"
import script from "./InvesteeInfo.vue?vue&type=script&lang=js&"
export * from "./InvesteeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports